import { CheckOutdatedIBANResponse } from 'api/evisaAPI/evisaAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  isOutdatedIBAN: boolean
} & Status

const initialState: State = {
  isOutdatedIBAN: false,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CHECK_OUTDATED_IBAN_ASYNC,
    Actions.CHECK_OUTDATED_IBAN_SUCCESS,
    Actions.CHECK_OUTDATED_IBAN_FAIL,
    CheckOutdatedIBANResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CHECK_OUTDATED_IBAN_ASYNC:
    case Actions.CHECK_OUTDATED_IBAN_FAIL:
      return {
        ...state,
        ...action.status,
      }
    case Actions.CHECK_OUTDATED_IBAN_SUCCESS:
      return {
        isOutdatedIBAN: action.payload.isHasOutdatediban,
        ...action.status,
      }
    default:
      return state
  }
}
